import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import SummarizeRoundedIcon from "@mui/icons-material/SummarizeRounded";

function Step3Privacy({ formData, errors, handleChange }) {
  return (
    <Box>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
          Ultimo step!
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Conferma il consenso al trattamento dei dati
        </Typography>
      </Box>

      <Stack spacing={2.5} sx={{ mb: 4 }}>
        <Paper
          elevation={0}
          sx={{
            p: 2.5,
            borderRadius: 2,
            border: errors.privacyAccettata ? 2 : 1,
            borderColor: errors.privacyAccettata ? "error.main" : "divider",
            bgcolor: "background.paper",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.privacyAccettata}
                onChange={(e) =>
                  handleChange("privacyAccettata", e.target.checked)
                }
                color="primary"
              />
            }
            label={
              <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                <Box component="span" sx={{ color: "error.main" }}>
                  *{" "}
                </Box>
                Vista l'
                <Box
                  component="span"
                  sx={{
                    color: "primary.main",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  informativa privacy
                </Box>
                , prendo atto che il trattamento dei miei dati è necessario
                all'erogazione dei servizi richiesti e dichiaro di aver compiuto
                18 anni.
              </Typography>
            }
          />
          {errors.privacyAccettata && (
            <Typography
              variant="caption"
              color="error"
              sx={{ mt: 1, display: "block", ml: 4 }}
            >
              È necessario accettare per continuare
            </Typography>
          )}
        </Paper>

        <Paper
          elevation={0}
          sx={{
            p: 2.5,
            borderRadius: 2,
            border: 1,
            borderColor: "divider",
            bgcolor: "background.paper",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.consensoPromozionali}
                onChange={(e) =>
                  handleChange("consensoPromozionali", e.target.checked)
                }
                color="primary"
              />
            }
            label={
              <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                Acconsento al trattamento per comunicazioni promozionali
                relative a prodotti e servizi analoghi a quelli richiesti
                <Box
                  component="span"
                  sx={{ color: "text.secondary", fontStyle: "italic" }}
                >
                  {" "}
                  (facoltativo)
                </Box>
              </Typography>
            }
          />
        </Paper>

        <Paper
          elevation={0}
          sx={{
            p: 2.5,
            borderRadius: 2,
            border: 1,
            borderColor: "divider",
            bgcolor: "background.paper",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.consensoPartner}
                onChange={(e) =>
                  handleChange("consensoPartner", e.target.checked)
                }
                color="primary"
              />
            }
            label={
              <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                Acconsento alla cessione dati a{" "}
                <Box
                  component="span"
                  sx={{
                    color: "primary.main",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  partner commerciali
                </Box>{" "}
                per finalità promozionali
                <Box
                  component="span"
                  sx={{ color: "text.secondary", fontStyle: "italic" }}
                >
                  {" "}
                  (facoltativo)
                </Box>
              </Typography>
            }
          />
        </Paper>
      </Stack>

      <Paper
        elevation={0}
        sx={{
          p: 3,
          bgcolor: "primary.lighter",
          borderRadius: 2,
          border: 1,
          borderColor: "primary.light",
        }}
      >
        <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
          <SummarizeRoundedIcon sx={{ color: "primary.main", fontSize: 24 }} />
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, color: "primary.dark" }}
          >
            Riepilogo richiesta:
          </Typography>
        </Box>
        <Stack spacing={1} sx={{ ml: 4.5 }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              • Servizio:
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {formData.servizio === "luce"
                ? "Luce"
                : formData.servizio === "gas"
                ? "Gas"
                : "Luce e Gas"}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              • Comune:
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {formData.comune}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              • Utenza:
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {formData.tipologia === "privato" ? "Privato" : "Business"}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              • Email:
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {formData.email}
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
}

export default Step3Privacy;
